import React, { useContext, useEffect, useState } from 'react'
import { Row, Col, Pagination, Offcanvas, Card } from 'react-bootstrap'
import { CiCircleCheck } from 'react-icons/ci'
import { FaCloudDownloadAlt, FaPlus, FaRegFileExcel } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { UserContext } from '../../context/UserContextProvider'
import APIServicenew from '../../utils/APIGeneralService'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useMenuPermissions from '../../components/CustomHook/custompermission'
import { formatDateTime, formatDateDMY, formatTime, capitalizeFirstLetter } from "../../utils/Helper"


const MomDetails = () => {
  const { id } = useParams();
  const [momDetails, setMomDetails] = useState({});
  const [followUpHistory, setFollowUpHistory] = useState({});
  const [members, setMembers] = useState([])
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const permissionscontext = useMenuPermissions("/admin/mom-list");
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [details, setDetails] = useState([]);
  const [total, setTotal] = useState(0)
  const [currency, setCurrency] = useState("")
  const [downloadButton, setDownloadButton] = useState("Download")
  useEffect(() => {
    fetchDetails(id);
    fetchMeetingNotesDetails(id);
  }, [id]);

  const fetchMeetingNotesDetails = async (momId) => {
    try {
      const response = await APIServices.get(
        `/admin/mom/details/${momId}`,
        headers
      );
      if (response?.status === 200) {
        setMomDetails(response?.data?.list || {});
        setMembers(response?.data?.members || []);
        setFollowUpHistory(response?.data?.followUpHistory || [])
        if (response?.data?.list?.action) {
          setEditorState(
            EditorState.createWithContent(convertFromRaw(JSON.parse(response?.data?.list?.action)))
          );
        }
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setMomDetails({});
      }
    } catch (error) {
      setMomDetails({});
    }
  };

  const fetchDetails = async (momId) => {
    try {
      const response = await APIServices.get(
        `/admin/mom/get_expenses/${momId}`,
        headers
      );
      if (response?.status === 200) {
        setCurrency(response?.data?.currency)
        setTotal(response?.data?.total)
        setDetails(response?.data?.list);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setDetails([]);
      }
    } catch (error) {
      setDetails([]);
    }
  };

  const downloadDoc = async (momId) => {
    try {
      setDownloadButton("Downloading...")
      const response = await APIServices.get(
        `/admin/mom/download_pdf/${momId}`,
        headers
      );
      if (response?.status === 200) {
        if (response?.data?.url) {
          setDownloadButton("Download")
          let url = response?.data?.url;
          // window.location.hsref = url;
          window.open(url);
        }
      } else if (response?.status === 401) {
        setDownloadButton("Download")
        logout();
        navigate("/");
      } else {
        setDownloadButton("Download")
        //setDetails([]);
      }
    } catch (error) {
      setDownloadButton("Download")
      // setDetails([]);
    }
  };


  return (
    <>
      <div className="momDetails_inner">
        <Row>
          <Col md={8} lg={8}>
            <h2 className="font_blue_18 font-600 mb-3">Minutes of Meeting Details</h2>

            <Card className="MoM_Details">
              <Card.Body>
                <Row className="align-items-center mb-3">
                  <div className="d-flex justify-content-between align-items-center flex_wrap w-100">
                    <h3 className="font_blue_18 font-500 mb-0">
                      {capitalizeFirstLetter(momDetails?.agenda)}
                    </h3>

                    <button className="btn blue_border d-flex align-items-center px-3" onClick={() => setShow(true)}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                        <path d="M22 12V17C22 20 20 22 17 22H7C4 22 2 20 2 17V12C2 9.28 3.64 7.38 6.19 7.06C6.45 7.02 6.72 7 7 7H17C17.26 7 17.51 7.00999 17.75 7.04999C20.33 7.34999 22 9.26 22 12Z" stroke="#0D082F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M17.7514 7.05C17.5114 7.01 17.2614 7.00001 17.0014 7.00001H7.00141C6.72141 7.00001 6.45141 7.02001 6.19141 7.06001C6.33141 6.78001 6.53141 6.52001 6.77141 6.28001L10.0214 3.02C11.3914 1.66 13.6114 1.66 14.9814 3.02L16.7314 4.79002C17.3714 5.42002 17.7114 6.22 17.7514 7.05Z" stroke="#0D082F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M22 12.5H19C17.9 12.5 17 13.4 17 14.5C17 15.6 17.9 16.5 19 16.5H22" stroke="#0D082F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Expenses
                    </button>
                  </div>
                </Row>

                <ul className="feature_launch">
                  <li className="d-flex align-items-center">
                    <img
                      src="/images/Calendarb.svg"
                      className="img-fluid me-2"
                      alt="image"
                    />
                    <p className="font_blue_16 ">
                      {`${formatDateDMY(
                        momDetails?.date
                      )}`}
                    </p>
                  </li>
                  <li className="d-flex align-items-center">
                    <img
                      src="/images/MapPointb.svg"
                      className="img-fluid me-2"
                      alt="image"
                    />
                    <p className="font_blue_16 ">
                      {momDetails?.address ?? "N/A"}
                    </p>
                  </li>
                  <li className="d-flex align-items-center">
                    <span className="font_blue_16 pe-3 border-end">
                      <img
                        src="/images/worldb.svg"
                        className="img-fluid me-2"
                        alt="image"
                      />
                      {momDetails?.region_name ?? "N/A"}
                    </span>
                  </li>
                </ul>

                {momDetails?.status && (
                  <div className="status d-flex align-items-center gap-2 pt-3">
                    <h4 className="font_blue_16 font-500">Status:</h4>
                    <span>{momDetails?.status}</span>
                  </div>
                )}
              
                <p className="font_blue_16 line-height26 pb-3  pt-3">
                  {momDetails?.description ?? "N/A"}
                </p>
                {momDetails?.relationship_manager_first_name &&
                  momDetails?.relationship_manager_type && (
                    <div className="d-flex align-items-center flex_wrap  gap-2 pb-3">
                      <h4 className="font_blue_16 font-500">
                        Relationship Manager:
                      </h4>
                      <span className="font_blue_16 textTransform">
                        {`${momDetails?.relationship_manager_first_name} ${momDetails?.relationship_manager_last_name} (${momDetails?.relationship_manager_type})`}{" "}
                      </span>
                    </div>
                  )}

                {momDetails?.product_name && (
                  <div className=" pb-3">
                    <h4 className="font_blue_16 font-500 mb-2">Products</h4>
                    <p className="font_blue_16 ">
                      {momDetails?.product_name ?? "N/A"}{" "}
                    </p>
                  </div>
                )}


                {momDetails?.channel_partner_name && (
                    <div className="d-flex align-items-center flex_wrap  gap-2 pb-3">
                      <h4 className="font_blue_16 font-500">
                        Channel Partners:
                      </h4>
                      <div class="d-flex align-items-center ">
                        <p className='textTransform'>{momDetails?.channel_partner_name}</p>
                      </div>
                    </div>
                  )}

                   {momDetails?.accomplished_with && (
                  <div className=" pb-3">
                    <h4 className="font_blue_16 font-500 mb-2">Accomplished with</h4>
                    <p className="font_blue_16 ">
                     {momDetails?.accomplished_with
                      ? `${momDetails.accomplished_with} (${momDetails.user_type})`
                      : "N/A"}
                    </p>
                  </div>
                )}

                {momDetails?.attechment && (
                  <div className="d-flex  flex-column  gap-2 pb-3 atte_doc">
                    <h4 className="font_blue_16 font-500 mb-2">
                      Attached Document
                    </h4>
                    {momDetails?.attechment.map((file, index) => (
                      <div className="doc_file" key={index}>
                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                          <FaRegFileExcel className="me-2" />
                          <span>{file.fileName}</span>
                        </a>
                      </div>
                    ))}
                  </div>
                )}

                {members.length > 0 && (
                  <div className="member_list_sec">
                    <h4 className="font_blue_16 font-500 mb-2">{`Members (${members.length})`}</h4>

                    <ul className="mamber_list">
                      {members?.map((member, index) => (
                        <li className={member.member_id == momDetails.created_by ? "cell-active" : ""} key={member.member_id}>
                          <ul className="d-flex align-items-center">
                            <li className="sr_n font_blue_14">{index + 1}</li> {/* This will show a dynamic serial number */}
                            <li className="user">
                              <div className="d-flex align-items-center">
                                {
                                  member?.profile_pic ?
                                    <img
                                      className="img-fluid me-2 table_user rounded-circle"
                                      alt="member profile"
                                      src={member?.profile_pic}
                                      onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                    />
                                    :
                                    <img src="/images/placeholder-img.jpg"
                                      className='img-fluid me-2 table_user'
                                      alt="default img"
                                    />
                                }
                                <p className="font_blue_14 textTransform">
                                  {member?.fullname}
                                  {member?.member_id == momDetails.created_by ? <b> (Owner) </b> : ""}
                                </p>
                              </div>
                            </li>
                            <li className="designation font_blue_14 textTransform">
                              {member?.user_type ?? "N/A"}
                            </li>
                          </ul>
                        </li>
                      ))}
                    </ul>

                  </div>
                )}
              </Card.Body>
              <Card.Footer className="d-flex justify-content-end flex_wrap">
                <button className="btn blue_border d-flex align-items-center me-2" onClick={() => navigate(`/admin/add-expenses/${id}`)}
                  disabled={!permissionscontext.add}
                >
                  <FaPlus className="me-2" />Add Expenses
                </button>
                <button onClick={() => downloadDoc(momDetails?.id)} className="btn blue_border d-flex align-items-center">
                  <FaCloudDownloadAlt className="me-2" /> {downloadButton}
                </button>
              </Card.Footer>
            </Card>
          </Col>
          <Col md={4} lg={4}>
            <h2 className="font_blue_18 font-600 mb-3 ">Action Points</h2>

            <Card className="MoM_Details Action_points">
              <Card.Body>
                <Editor editorState={editorState} toolbarHidden readOnly />
                {momDetails?.next_followup_date &&
                  momDetails?.next_followup_time && (
                    <div className="next_follow py-3 d-flex align-items-start justify-content-between">
                      <div>
                        <h4 className="font_blue_16 font-500 mb-2">
                          Next Follow Up:{" "}
                        </h4>
                        <p className="font_blue_16 ">
                          {`${formatDateDMY(
                            momDetails?.next_followup_date
                          )} at ${formatTime(momDetails?.next_followup_time)}`}
                        </p>
                      </div>
                      {momDetails?.follow_up_status === "Complete" ? (
                        <button className="btn btn-success">Completed</button>
                      ) : momDetails?.follow_up_status === "Cancelled" ? (
                        <button className="btn btn-danger">Cancelled</button>
                      ) : ""}
                    </div>
                  )}

                <div className="mt-2">
                  {
                    !(followUpHistory && followUpHistory.length > 0) ? (
                      <button
                        className="btn red_button d-flex align-items-center"
                        onClick={() =>
                          navigate("/admin/add-mom", {
                            // state: { row: { parent_mom_id: id } },
                            state: { row: momDetails },                            
                          })
                        }
                        disabled={!permissionscontext.add}
                      >
                        <FaPlus className="me-1" /> Add Follow Up
                      </button>
                    ) : null
                  }

                </div>
                 <hr></hr>
                <div className='mt-2'>
                  {followUpHistory.length > 0 && (
                    <div className="next_follow py-3 d-flex align-items-start justify-content-between">
                      <div>
                        <h4 className="font_blue_16 font-500 mb-2">
                          Follow Up History
                        </h4>
                        <ul>
                          {followUpHistory.map((history) => (
                            <li key={history.id} className="font_blue_16 mt-1"
                              disabled={!permissionscontext.view}
                              style={{
                                cursor: "pointer"
                              }}
                              onClick={() =>
                                navigate(`/admin/mom-details/${history.id}`)
                              }
                            >
                              <u>{`${history?.agenda} (${formatDateDMY(
                                history?.date
                              )}`}</u>
                              <img style={{ margin: "0px 10px" }}
                                src="/images/Eye.svg"
                                className="img-fluid"
                                alt="Eye.svg"
                              />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div >
      <Offcanvas
        className="notificaion_canvas expenses_canvas "
        show={show}
        onHide={() => setShow(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton className="position-relative">
          <Offcanvas.Title className="font_blue_18 font-600">
            Expenses
          </Offcanvas.Title>

          <div className="d-flex align-items-center justify-content-between w-100 mt-2">
            <span className='font_blue_18'> Total</span>
            <span className='font_blue_18 red' > {currency}{total}</span>
          </div>

        </Offcanvas.Header>
        <Offcanvas.Body>

          <ul className="list-group">
            {details?.length === 0 ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                <span>Not Available</span>
              </div>
            ) : (
              details.map((item, index) => (
                <li className="list-group-item" key={index}>
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="me-2" style={{ flex: 1, minWidth: 0 }}>
                      <h3 className="font_blue_16 font-500 mb-1 text-break">{item.title}</h3>
                      <p className="font_grey_12 mb-0 text-break">{item?.date_time}</p>
                    </div>
                    <span className="font_blue_14 font-600 text-nowrap ms-2">
                      {currency}{item?.price}
                    </span>
                  </div>
                </li>
              ))
            )}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default MomDetails